import React, {Component} from 'react';
import {Form, Popover, Table} from 'antd';
import DescriptionList from '@comm/DescriptionList';
import {Link} from 'react-router';
import moment from 'moment';
import util from '@util/index';
import {queryInvoiceType} from '@api/core/dict';
import {queryInvoiceList} from '@api/incubator/invoice';

const { Description } = DescriptionList;

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        list: [],
        pagination: {},
      },
      invoiceType: {},
    };
  }

  componentDidMount() {
    this.getInvoiceType();
    this.loadData();
  }

  handleChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    this.loadData();
  };

  getInvoiceList = params => {
    queryInvoiceList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: {
            list: res.data,
            pagination: {
              current: this.current || 1,
              total: res.totalSize,
              pageSize: params.limit,
            },
          },
        });
      }
    });
  };

  getInvoiceType = () => {
    queryInvoiceType().then(res => {
      if (res.statusCode === 200) {
        const invoiceType = {};
        res.data.forEach(item => {
          invoiceType[item.value] = item.key;
        });
        this.setState({
          invoiceType,
        });
      }
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.sorter,
      limit: this.props.pageSize,
      start: this.current || 1,
      customUuid: this.props.customUuid,
      incubatorUuid: this.props.incubatorUuid,
    };
    this.getInvoiceList(params);
  };

  columns = () => {
    const getContent = content => (
      <div style={{ width: '300px' }}>
        <DescriptionList size="large" col={1}>
          <Description term="作废原因">{content.invalidReason}</Description>
          <Description term="操作人员">{content.invalidUser}</Description>
          <Description term="操作时间">
            {content.invalidDate
              ? moment.unix(content.invalidDate / 1000).format('YYYY-MM-DD')
              : null}
          </Description>
        </DescriptionList>
      </div>
    );
    const { invoiceType } = this.state;
    return [
      {
        title: '开票编号',
        dataIndex: 'no',
        width: 150,
        render: (text, record) => (
          <Link to={`/incubator/invoice_manage/open/${record.uuid}`}>{text}</Link>
        ),
      },
      {
        title: '客户',
        dataIndex: 'custom',
        key: 'custom',
        width: 150,
        render: (text, record) => (
          <span>
            {record.custom}
            {record.projectName ? `(${record.projectName})` : ''}
          </span>
        ),
      },
      {
        title: '收款公司',
        dataIndex: 'company',
        key: 'company',
      },
      {
        title: '开票类型',
        dataIndex: 'type',
        key: 'type',
        render: text => <span>{invoiceType[text]}</span>,
      },
      {
        title: '开票金额',
        dataIndex: 'price',
        key: 'price',
        render: text => <span>{util.numberFormat(text)}</span>,
      },
      {
        title: '申请理由',
        dataIndex: 'reason',
        key: 'reason',
        width: 150,
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{moment.unix(text / 1000).format('YYYY-MM-DD')}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'long',
        render: (text, record) => {
          const instance = record.instance || {};
          let element;
          if (instance.status === 1) {
            element = <span style={{ color: 'red' }}>已完成</span>;
          } else {
            element = record.instance ? <span>处理中</span> : <span>待编辑</span>;
          }
          return element;
        },
      },
      {
        title: '作废情况',
        dataIndex: 'invalid',
        render: (text, record) => (
          <span>
            {record.invalid ? (
              <Popover content={getContent(record)} title="作废详情">
                已作废
              </Popover>
            ) : (
              ''
            )}
          </span>
        ),
      },
    ];
  };

  render() {
    const {
      data: { list, pagination },
    } = this.state;
    return (
      <div>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          rowKey="uuid"
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/incubator/invoice/TableInvoice.js